import Nullstack from 'nullstack';
export default function IconTrophyOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-trophy-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 21h8"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v4"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h9"
  }), "   ", Nullstack.element("path", {
    d: "M17 4v8c0 .31 -.028 .612 -.082 .905m-1.384 2.632a5 5 0 0 1 -8.534 -3.537v-5"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "9",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "9",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}